import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Modal from '../router/Modal'
import Button, { StyledButton } from '../button/Button'
import { setConfirm } from '../../state/actions/app'
import { mobile } from '../../styles/media'
import Input, { StyledInputContainer } from '../form/Input'
import { StyledMessage } from '../form/Message'
import RadioContainer from '../form/RadioContainer'
import RadioAlternative from '../form/RadioAlternative'
import Icon from '../general/Icon'

class Confirm extends Component {
	constructor(props) {
		super(props)

		this.state = {
			visible: this.props.confirm !== null,
			loading: false,
			input: null,
			options: null,
			selectedOption: null,
			fieldErrors: {}
		}

		this.inputRef = React.createRef()
	}


	componentDidUpdate(prevProps) {
		const { confirm } = this.props

		if (prevProps.confirm !== confirm) {
			this.setState({
				visible: confirm !== null,
				input: confirm && confirm.input !== undefined ? confirm.input || '' : null,
				options: confirm && confirm.options !== undefined ? confirm.options || [] : null,
				selectedOption: confirm && confirm.options !== undefined && confirm.options.length > 0 ? confirm.options[0].value : null,
				fieldErrors: {},
				loading: false
			}, () => {
				if (this.state.visible) {
					window.addEventListener('keydown', this.handleKeyDown)

					if (confirm.input !== undefined) {
						this.inputRef.current.select()
					}
				} else {
					window.removeEventListener('keydown', this.handleKeyDown)
				}
			})
		}
	}

	handleKeyDown = (event) => {
		if (event.key === 'Escape') {
			this.close(true)
		}
	}

	handleInputKeyDown = (event) => {
		const { input } = this.state

		if (event.key === 'Enter' && input !== null && input !== '') {
			this.handleClickSuccess()
		}
	}

	handleClickSuccess = () => {
		const { confirm } = this.props
		const { input, selectedOption } = this.state

		if (confirm.onSubmit) {
			this.setState({
				loading: true
			}, () => {
				confirm.onSubmit(this.close, this.handleError, input || selectedOption)
			})
		} else {
			this.close()
			this.props.confirm.success(input)
		}
	}

	handleError = (fieldErrors) => {
		this.setState({
			fieldErrors,
			loading: false
		})
	}

	handleClickSecondary = () => {
		this.close()
		this.props.confirm.secondary()
	}

	handleClickAway = () => {
		const { loading } = this.state

		if (!loading) {
			this.close()
		}
	}

	close = (isCancel = false) => {
		const { confirm } = this.props

		this.setState({
			visible: false,
			loading: false
		}, () => {
			if (isCancel && confirm.cancel) {
				confirm.cancel()
			}
			window.setTimeout(() => setConfirm(null), 500)
		})
	}

	render() {
		const { confirm } = this.props
		const { input, options, selectedOption, visible, loading, fieldErrors } = this.state

		return (
			<Modal
				center
				visible={visible}
				onClickAway={this.handleClickAway}
				width={confirm && confirm.width ? confirm.width : undefined}
			>
				<ConfirmText>{confirm && confirm.text}</ConfirmText>

				{input !== null && options === null && (
					<ConfirmFormField>
						<Input
							type={confirm && confirm.inputType ? confirm.inputType : 'text'}
							value={input}
							onChange={input => this.setState({ input })}
							onKeyDown={this.handleInputKeyDown}
							inputRef={this.inputRef}
							errors={fieldErrors.input}
						/>
					</ConfirmFormField>
				)}

				{options !== null && input === null && (
					<ConfirmFormField>
						<RadioContainer
							value={selectedOption}
							onChange={selectedOption => this.setState({ selectedOption })}
						>
							{options.map(option => (
								<RadioAlternative
									icon={<Icon name={option.icon} />}
									name={option.value}
									label={option.label}
									key={option.value}
								/>
							))}
						</RadioContainer>
					</ConfirmFormField>
				)}

				<ConfirmButtons>
					<Button
						red={confirm && (typeof confirm.submitRed !== 'undefined' ? confirm.submitRed : input === null)}
						onClick={this.handleClickSuccess}
						loading={loading}
						disabled={loading || input === ''}
					>
						{confirm && confirm.submitText}
					</Button>
					{confirm && confirm.secondaryText && (
						<Button
							red={typeof confirm.secondaryRed !== 'undefined' ? confirm.secondaryRed : false}
							onClick={this.handleClickSecondary}
							disabled={loading}
						>
							{confirm && confirm.secondaryText}
						</Button>
					)}
					<Button
						secondary
						disabled={loading}
						onClick={this.close}
					>
						{confirm && confirm.cancelText}
					</Button>
				</ConfirmButtons>
			</Modal>
		)
	}
}

Confirm.propTypes = {
	confirm: PropTypes.object,
}

Confirm.defaultProps = {
	confirm: null
}

const ConfirmText = styled.p`
	font-size: 1.1rem;
	font-weight: 600;
	margin-bottom: 2rem;
	text-align: center;
`

const ConfirmFormField = styled.div`
	margin-bottom: 2rem;

	${StyledInputContainer} {
		width: 100%;
	}

	input {
		font-size: 1.1rem;
		font-weight: 500;
		padding: 0.75rem;
		text-align: center;
		width: 100% !important;
	}

	${StyledMessage} {
		margin: 0.5rem 0 0;
	}
`

const ConfirmButtons = styled.div`
	display: flex;
	justify-content: center;

	${mobile`
		${StyledButton} + ${StyledButton} {
			margin: 0 0 0 0.5rem;
		}

		${StyledButton} {
			border-radius: 8px;
			font-size: 0.9rem;
			flex: 1;
			padding: 0.5rem;
		}
	`}
`

const enhance = connect(state => ({
	confirm: state.app.confirm
}), dispatch => bindActionCreators({
	setConfirm
}, dispatch))

export default enhance(Confirm)
